// ABOUTME: Static terms of service page for Daubly.
// ABOUTME: Covers acceptable use, content ownership, liability, and governing law.
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import MuiLink from '@mui/material/Link'

export function TermsPage() {
  return (
    <Container maxWidth="md">
      <Box py={6}>
        <Typography variant="h3" component="h1" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Effective date: March 1, 2026
        </Typography>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By creating an account or using Daubly, you agree to these Terms of Service. If you
            do not agree, please do not use the service. These terms apply to all users,
            including hosts who create games and players who join them.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Use of Service
          </Typography>
          <Typography paragraph>
            Daubly is a platform for creating and playing bingo games. You agree to use it only
            for lawful purposes and in a way that does not infringe the rights of others or
            restrict their use of the service.
          </Typography>
          <Typography paragraph>
            You must be at least 13 years old to create an account. By using Daubly, you
            represent that you meet this requirement. You are responsible for maintaining the
            security of your account and for all activity that occurs under it.
          </Typography>
          <Typography paragraph>
            You agree not to: attempt to gain unauthorized access to any part of the service;
            use automated tools to scrape or abuse the platform; transmit harmful, offensive,
            or unlawful content through your games or square packs.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Your Content
          </Typography>
          <Typography paragraph>
            You retain ownership of the content you create on Daubly — your square packs, game
            configurations, and any text you enter. By using the service, you grant Daubly a
            limited license to store and display your content solely to provide the service to
            you and your game participants.
          </Typography>
          <Typography paragraph>
            You are responsible for ensuring your content does not violate any laws or
            third-party rights. We reserve the right to remove content that violates these
            terms.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Account Termination
          </Typography>
          <Typography paragraph>
            You may delete your account at any time from your account settings. We may suspend
            or terminate your account if you violate these terms, with or without notice
            depending on the severity of the violation.
          </Typography>
          <Typography paragraph>
            Upon termination, your right to use the service ends immediately. Sections of these
            terms that by their nature should survive termination will do so, including
            disclaimers of warranty and limitations of liability.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Disclaimer of Warranties
          </Typography>
          <Typography paragraph>
            Daubly is provided "as is" and "as available" without warranties of any kind, either
            express or implied. We do not warrant that the service will be uninterrupted,
            error-free, or free of harmful components. Your use of the service is at your own
            risk.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Limitation of Liability
          </Typography>
          <Typography paragraph>
            To the fullest extent permitted by law, Daubly and its operators will not be liable
            for any indirect, incidental, special, consequential, or punitive damages arising
            from your use of the service, even if we have been advised of the possibility of
            such damages.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Governing Law
          </Typography>
          <Typography paragraph>
            These terms are governed by the laws of the State of Delaware, United States,
            without regard to its conflict of law provisions. Any disputes arising under these
            terms will be resolved in the courts located in Delaware.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Changes to Terms
          </Typography>
          <Typography paragraph>
            We may update these terms from time to time. When we do, we will update the
            effective date at the top of this page. Continued use of Daubly after changes
            are posted constitutes your acceptance of the updated terms.
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h5" component="h2" gutterBottom>
            Contact
          </Typography>
          <Typography paragraph>
            Questions about these Terms of Service? Contact us at{' '}
            <MuiLink href="mailto:legal@daubly.com">legal@daubly.com</MuiLink>.
          </Typography>
        </Box>
      </Box>
    </Container>
  )
}
